export default "__VITE_ASSET__DBJolr6g__"